import ContentLoader from "react-content-loader";

export const LoadingFaq = () => (
  <div className="grid grid-cols-1 gap-2">
    <div className="w-full h-8">
      <ContentLoader width="100%" height="32px" foregroundColor="#EDF2F7">
        <rect x="0" y="0" rx="10" ry="10" width="100%" height={32} />
      </ContentLoader>
    </div>

    <div className="w-full h-6">
      <ContentLoader width="40%" height="24px" foregroundColor="#EDF2F7">
        <rect x="0" y="0" rx="8" ry="8" width="100%" height={24} />
      </ContentLoader>
    </div>
  </div>
);

export const LoadingSearchFaq = () => (
  <div className="w-full h-[4.813rem]">
    <ContentLoader width="100%" height="77px" foregroundColor="#EDF2F7">
      <rect x="0" y="0" rx="16" ry="16" width="100%" height={77} />
    </ContentLoader>
  </div>
);

export const LoadingFacilityDetail = () => (
  <>
    <div className="w-full lg:w-[55%]">
      <div className="flex flex-col gap-3">
        <ContentLoader width="100%" height="16px" foregroundColor="#F1F5F9">
          <rect x="0" y="0" rx="4" ry="4" width="100%" height={16} />
        </ContentLoader>
        <ContentLoader width="40%" height="28px" foregroundColor="#F1F5F9">
          <rect x="0" y="0" rx="4" ry="4" width="100%" height={28} />
        </ContentLoader>
        <ContentLoader width="35%" height="16px" foregroundColor="#F1F5F9">
          <rect x="0" y="0" rx="4" ry="4" width="100%" height={16} />
        </ContentLoader>
      </div>
      <div className="mt-6">
        <ContentLoader width="100%" height="54px" foregroundColor="#F1F5F9">
          <rect x="0" y="0" rx="12" ry="12" width="100%" height={54} />
        </ContentLoader>
      </div>
      <div className="mt-6 grid grid-cols-1 gap-4.5">
        {Array.from({
          length: 3,
        }).map((_, key) => (
          <div key={key} className="flex items-center gap-3">
            <div className="w-1/3">
              <ContentLoader
                width="100%"
                height="16px"
                foregroundColor="#F1F5F9"
              >
                <rect x="0" y="0" rx="4" ry="4" width="100%" height={16} />
              </ContentLoader>
            </div>
            <div className="w-2/3">
              <ContentLoader
                width="100%"
                height="16px"
                foregroundColor="#F1F5F9"
              >
                <rect x="0" y="0" rx="4" ry="4" width="100%" height={16} />
              </ContentLoader>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-7 grid grid-cols-1">
        {Array.from({
          length: 3,
        }).map((_, key) => (
          <div key={key} className="flex gap-3.5 py-3.5">
            <div className="min-w-[4.5rem] w-[4.5rem]">
              <ContentLoader
                width="100%"
                height="72px"
                foregroundColor="#F1F5F9"
              >
                <rect x="0" y="0" rx="16" ry="16" width="100%" height={72} />
              </ContentLoader>
            </div>
            <div className="flex flex-col gap-3 w-full">
              <div className="">
                <ContentLoader
                  width="100%"
                  height="16px"
                  foregroundColor="#F1F5F9"
                >
                  <rect x="0" y="0" rx="4" ry="4" width="100%" height={16} />
                </ContentLoader>
              </div>
              <div>
                <ContentLoader
                  width="20%"
                  height="16px"
                  foregroundColor="#F1F5F9"
                >
                  <rect x="0" y="0" rx="4" ry="4" width="100%" height={16} />
                </ContentLoader>
              </div>
              <div>
                <ContentLoader
                  width="40%"
                  height="16px"
                  foregroundColor="#F1F5F9"
                >
                  <rect x="0" y="0" rx="4" ry="4" width="100%" height={16} />
                </ContentLoader>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
    <div className="lg:w-[45%] hidden lg:block">
      <div className="border border-neutral-100 rounded-3xl py-6 px-14 flex flex-col items-center justify-center gap-20">
        <div className="relative mt-[6rem]">
          <div className="bg-primary-50 rounded-3xl w-[13.625rem] h-[13.625rem]" />
          <div className="absolute -top-1/3 -right-[38%]">
            <div className="w-[15.125rem] h-[15.125rem]">
              <ContentLoader
                width="100%"
                height="100%"
                foregroundColor="#EDF2F7"
              >
                <rect x="0" y="0" rx="24" ry="24" width="100%" height="100%" />
              </ContentLoader>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-4.5 w-full">
          <div className="text-large-none font-bold text-neutral-900">
            Open Hours
          </div>
          <div className="grid grid-cols-1 gap-3.5">
            {Array.from({ length: 3 }).map((_, key) => (
              <div key={key}>
                <ContentLoader
                  width="100%"
                  height="14px"
                  foregroundColor="#EDF2F7"
                >
                  <rect x="0" y="0" rx="4" ry="4" width="100%" height={14} />
                </ContentLoader>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </>
);

export const LoadingBlog = () => (
  <>
    <div className="flex flex-col">
      <div>
        <ContentLoader width="100%" height="250px" foregroundColor="#EDF2F7">
          <rect x="0" y="0" rx="16" ry="16" width="100%" height="250" />
        </ContentLoader>
      </div>
      <div className="mt-3.5 flex flex-col gap-3 w-full">
        <div>
          <ContentLoader width="100%" height="16px" foregroundColor="#EDF2F7">
            <rect x="0" y="0" rx="4" ry="4" width="20%" height="16" />
          </ContentLoader>
        </div>
        <div>
          <ContentLoader width="100%" height="16px" foregroundColor="#EDF2F7">
            <rect x="0" y="0" rx="4" ry="4" width="100%" height="16" />
          </ContentLoader>
        </div>
        <div>
          <ContentLoader width="100%" height="16px" foregroundColor="#EDF2F7">
            <rect x="0" y="0" rx="4" ry="4" width="50%" height="16" />
          </ContentLoader>
        </div>
        <div>
          <ContentLoader width="100%" height="16px" foregroundColor="#EDF2F7">
            <rect x="0" y="0" rx="4" ry="4" width="100%" height="16" />
          </ContentLoader>
        </div>
        <div>
          <ContentLoader width="100%" height="16px" foregroundColor="#EDF2F7">
            <rect x="0" y="0" rx="4" ry="4" width="50%" height="16" />
          </ContentLoader>
        </div>
      </div>
    </div>
  </>
);
